import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { useFormikContext } from "formik";
import { FC } from "react";
import {
    addClientInviteRoleOptions,
    ClientFormSchema,
} from "../AddClientSteps/lib";
import styles from "./InviteStep.module.scss";
import drawerStyles from "./AddClientDrawerSteps.module.scss";

const fields = createFormikFields<ClientFormSchema>();

export const InviteStep: FC = () => {
    const { values } = useFormikContext<ClientFormSchema>();

    return (
        <div className={drawerStyles.container}>
            <div className={drawerStyles.header}>
                Invite your client to Kick?
            </div>
            <div className={drawerStyles.subheader}>
                {values.isMultiEntity
                    ? "The client is added to all entities. Skip to manage invites per entity in workspace settings."
                    : "You can manage invites later in workspace settings."}
            </div>

            <div className={styles.form}>
                <fields.Emails
                    name="invite.emails"
                    label="Email address"
                    className={styles.emailField}
                    placeholder="name@company.com"
                />

                <fields.Select
                    name="invite.role"
                    label="Role"
                    className={styles.roleField}
                    options={addClientInviteRoleOptions}
                    placeholder="Select role"
                    buttonProps={{ size: "xl" }}
                />
            </div>
        </div>
    );
};
